exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  background-color: #f2f2f2;\n  border-bottom: 1px solid #eee;\n  display: block;\n  height: 30px;\n  padding: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/randonneurs-2018-build-and-to-local/src/app/core/toolbar/toolbar.component.scss
// module id = ../../../../../src/app/core/toolbar/toolbar.component.scss
// module chunks = main